"use client";
import React, {useEffect, useState} from 'react';
import {setCookie, hasCookie, getCookie} from 'cookies-next';
import Button from "app/components/Button/Button";
import {usePhrase} from "../../i18n";
import {sendGTMEvent} from "@next/third-parties/google";
import {usePathname} from "next/navigation";

export default function CookieConsent({_t}) {

    const t = usePhrase(_t);

    const [popOpen, setPopOpen] = useState(false);

    const [consent, setConsent] = useState(null);


    const [necessary, setNecessary] = useState(true);
    const [preferences, setPreferences] = useState(true);
    const [statistics, setStatistics] = useState(true);
    const [marketing, setMarketing] = useState(true);


    const [adStorage, setAdStorage] = useState(true);
    const [adUserData, setAdUserData] = useState(true);
    const [adPersonalization, setAdPersonalization] = useState(true);
    const [analyticsStorage, setAnalyticsStorage] = useState(true);
    const [functionalityStorage, setFunctionalityStorage] = useState(true);
    const [personalizationStorage, setPersonalizationStorage] = useState(true);
    const [securityStorage, setSecurityStorage] = useState(true);

    const pathname = usePathname();

    useEffect(() => {
        //console.log(hasCookie('localConsent'));

        let defaultConsent = {
            adStorage: true,
            adUserData: true,
            adPersonalization: true,
            analyticsStorage: true,
            functionalityStorage: true,
            personalizationStorage: true,
            securityStorage: true
        };

        if (hasCookie('localConsent')) {
            // if cookie value is json
            try {
                let consents = JSON.parse(getCookie('localConsent'));
                //console.log(consents);
                if (typeof consents !== 'object' || !consents) {
                    throw new Error('Not an array');
                }
                Object.keys(consents).map(type => {
                    switch (type) {
                        case 'adStorage':
                            setAdStorage(consents[type]);
                            setMarketing(consents[type]);
                            break;
                        case 'adUserData':
                            setAdUserData(consents[type]);
                            setMarketing(consents[type]);
                            break;
                        case 'adPersonalization':
                            setAdPersonalization(consents[type]);
                            setMarketing(consents[type]);
                            break;
                        case 'analyticsStorage':
                            setAnalyticsStorage(consents[type]);
                            setStatistics(consents[type]);
                            break;
                        case 'functionalityStorage':
                            setFunctionalityStorage(consents[type]);
                            setPreferences(consents[type]);
                            break;
                        case 'personalizationStorage':
                            setPersonalizationStorage(consents[type]);
                            setPreferences(consents[type]);
                            break;
                        case 'securityStorage':
                            setSecurityStorage(consents[type]);
                            setNecessary(consents[type]);
                            break;
                    }
                });
                setConsent(JSON.stringify({
                    adStorage: adStorage,
                    adUserData: adUserData,
                    adPersonalization: adPersonalization,
                    analyticsStorage: analyticsStorage,
                    functionalityStorage: functionalityStorage,
                    personalizationStorage: personalizationStorage,
                    securityStorage: securityStorage
                }));

                //setCookie('localConsent', JSON.stringify(consents), {maxAge: 60 * 60 * 24 * 365});

            } catch (e) {
                console.error('localconsent deleted', e);
                setCookie('localConsent', null, {maxAge: -1});
                setPopOpen(true);
                // delete cookie
                // if cookie value is not json
                //setCookie('localConsent', JSON.stringify(defaultConsent), {maxAge: 60 * 60 * 24 * 365});
            }
        }else{
            setPopOpen(true)
        }


    }, []);

    useEffect(() => {
        //return () => {
        //console.log('consent:' + consent);
        if (consent) {
            sendGTMEvent({
                event: 'consent_update'
            });
            /* sendGTMEvent({
                 event: 'consent_allow'
             });*/
            //sendGTMEvent('event','consent_update');

            //console.log('accepting cookies');
        } else {
            //console.log('consent false');
        }
        // };

    }, [consent,pathname]);

    const acceptCookie = () => {
        //setConsent(true);
        //setCookie('localConsent', 'true', {maxAge: 60 * 60 * 24 * 365});

        let newConsent = {
            adStorage: adStorage,
            adUserData: adUserData,
            adPersonalization: adPersonalization,
            analyticsStorage: analyticsStorage,
            functionalityStorage: functionalityStorage,
            personalizationStorage: personalizationStorage,
            securityStorage: securityStorage
        };

        setCookie('localConsent', JSON.stringify(newConsent), {maxAge: 60 * 60 * 24 * 365});
        setConsent(JSON.stringify(newConsent));
        setPopOpen(false);
        // page reload
        window.location.reload();


    };
    const closeP = () => {
        setConsent(true);
        //console.log('closing');
    };
    const denyCookie = () => {
        setConsent(true);
        setCookie('localConsent', 'false', {maxAge: 60 * 60 * 24 * 365});
        //console.log('denying cookie');
    };


    const handleSetNecessary = (value) => {
        setNecessary(value);
        setSecurityStorage(value)
    }

    const handleSetPreferences = (value) => {
        setPreferences(value);
        setFunctionalityStorage(value);
        setPersonalizationStorage(value);
    }

    const handleSetStatistics = (value) => {
        setStatistics(value);
        setAnalyticsStorage(value);
    }

    const handleSetMarketing = (value) => {
        setMarketing(value);
        setAdStorage(value);
        setAdUserData(value);
        setAdPersonalization(value);
    }



    return (
        <>
        {(popOpen) ? <div data-nosnippet
                 className={`fixed top-0 left-0 w-full h-full bg-gray-400/60 z-[999] overflow-hidden flex justify-center items-center ${
                     (!popOpen) ? 'hidden' : ''
                 }`}
            >
                <div className={`bg-white rounded-md  h-auto p-10  max-w-[90%]`}>
                    <div><p
                        className={'mb-2 font-bold'}>{t('This website uses cookies to improve the browsing experience and to provide additional functionalities.')}</p>
                        <p className={'mb-2 text-sm'}>
                            {t('These data are completely anonymous, used for technical or statistic purposes and will not be used to identify you or contact you.')}<br/>
                            {t('This website may use third-party cookies. Further information is provided in the privacy policy.')}<br/>
                            {t('This website may use profiling cookies. Further information is provided in the privacy policy.')}<br/>
                            {t('To learn how this website uses cookies or localStorage, please read the privacy policy.')}
                        </p>
                    </div>
                    <div className={`grid grid-cols-2 lg:grid-cols-4`}>

                        <div className={`flex space-x-2 items-center `}>
                            <input type="checkbox" checked={necessary} readOnly={true} disabled={true}
                                   onChange={() => handleSetNecessary(!necessary)}/>
                            <label>{t('Necessary')}</label>
                        </div>
                        <div className={`flex space-x-2 items-center `}>
                            <input type="checkbox" checked={preferences}
                                   onChange={() => handleSetPreferences(!preferences)}/>
                            <label>{t('Preferences')}</label>
                        </div>
                        <div className={`flex space-x-2 items-center `}>
                            <input type="checkbox" checked={statistics}
                                   onChange={() => handleSetStatistics(!statistics)}/>
                            <label>{t('Statistics')}</label>
                        </div>
                        <div className={`flex space-x-2 items-center `}>
                            <input type="checkbox" checked={marketing} onChange={() => handleSetMarketing(!marketing)}/>
                            <label>{t('Marketing')}</label>
                        </div>
                    </div>
                    <div className="flex items-center justify-center mt-3">
                        {/*  <Button onClick={denyCookie} className="bg-red-400">{t('Deny All')}</Button>*/}
                        <Button onClick={acceptCookie}>{t('Accept')}</Button>
                    </div>
                    <div className={'mt-2'}>
                        <p className={'text-xs'}>
                            {t('To learn more about cookies and localStorage, please visit the website of the <a className="underline" href="https://www.dataprotection.ie/" target="_blank">Data Protection Commission</a>.')}
                        </p>
                    </div>
                </div>
            </div> :
            <div className={`absolute bottom-5 left-3 text-white text-sm cursor-pointer`} onClick={()=>setPopOpen(true)}>{t('Manage Cookies')}</div>}
        </>
    )
        ;
}
